import { colors, Divider, Tab, Tabs } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AuthGuard, ErrorMessage, GenericHeader, LoadingIndicator, Page, RenderGuard } from "components";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from "react-router-dom";
import { InventoryItem } from "services";
import { ModelsActions } from "store/actions";
import { ecommerce_manager } from 'utils/constants';
import useErrorCatcher from "utils/useErrorCatcher";
import { Summary } from "./components";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  tabs: {
    marginTop: theme.spacing(3)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(3)
  }
}));

let mounted = false;

const InventoryItemDetail = props => {
  const { match, history } = props;
  const classes = useStyles();
  const { item_id, tab } = match.params;
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));
  const model = useSelector(state => state.models.item);
  const dispatch = useDispatch();

  useEffect(() => {
    mounted && setLoading(true);
    runAsyncBlock(async () => {
      const { model } = await InventoryItem.detail(item_id);
      dispatch(ModelsActions.update_model({ item: model }));
    }).finally(() => mounted && setLoading(false));

    // eslint-disable-next-line
  }, [item_id]);

  useEffect(() => {
    mounted = true;
    return () => {
      mounted = false;
    }
  }, []);

  const handleTabsChange = (event, value) => {
    history.push(value);
  };

  const tabs = [
    { value: "summary", label: "Summary" },
  ];

  if (!tab) {
    return <Redirect to={`/items/${item_id}/summary`} />;
  }

  if (!tabs.find(t => t.value === tab)) {
    return <Redirect to="/errors/error-404" />;
  }

  return (
    <AuthGuard roles={[ecommerce_manager]} projects={[]}>
      <Page className={classes.root} title="Item Details" >
        <ErrorMessage message={errorMessage} />
        <LoadingIndicator variant="card" active={loading} />
        <RenderGuard renderIf={!loading && model}>
          {model && <GenericHeader subheader={model.item_class.label} header="Item" />}
          <Tabs
            className={classes.tabs}
            onChange={handleTabsChange}
            scrollButtons="auto"
            value={tab}
            variant="scrollable" >
            {tabs.map(tab => <Tab key={tab.value} label={tab.label} value={tab.value} />)}
          </Tabs>
          <Divider className={classes.divider} />
          <div className={classes.content}>
            {tab === "summary" && <Summary />}
          </div>
        </RenderGuard>
      </Page>
    </AuthGuard>
  );
};

InventoryItemDetail.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default InventoryItemDetail;
